<template>
    <AppLayout
        page="/help-categories"
        :pageTitle="helpCategory.title"
        :class="$page.props.staffView ? null : 'container'"
        :backLink="route('help-categories.index')"
        :tabs="true"
    >
        <template #tabs>
            <v-breadcrumbs
                class="px-1 py-3"
                :items="breadcrumbs"
            ></v-breadcrumbs
        ></template>
        <v-container>
            <v-row>
                <v-col cols="12">
                    <v-card
                        class="soli-round"
                        flat
                        v-for="(card, idx) in articles"
                        :key="card.id"
                    >
                        <Link :href="route('help-articles.show', card.id)">
                            <v-card-title
                                @click="
                                    $inertia.visit(
                                        route('help-articles.show', card.id)
                                    )
                                "
                                class="accent--text text-h5"
                                >{{ card.title }}</v-card-title
                            >
                            <v-card-subtitle
                                class="soli-grey"
                                :title="card.updated_at"
                                >Last updated
                                {{ card.updated_at_display }}</v-card-subtitle
                            >
                            <v-card-text
                                class="soli-grey"
                                v-html="card.excerpt"
                            ></v-card-text>
                        </Link>
                        <v-divider v-if="idx !== articles.length - 1" />
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </AppLayout>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout.vue";
import Card from "../../Components/HelpArticles/Card";
import { Link } from "@inertiajs/vue2";
import CRMDrawer from "../../Layouts/CRMDrawer.vue";

export default {
    layout: CRMDrawer,
    name: "HelpCategories",
    components: {
        AppLayout,
        Card,
        Link,
    },
    props: {
        articles: {
            type: Array,
            default: () => [],
        },
        helpCategory: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {};
    },
    methods: {},
    computed: {
        breadcrumbs() {
            return [
                {
                    text: "Help",
                    href: route("help-categories.index"),
                },
                {
                    text: this.helpCategory.title,
                },
            ];
        },
    },
};
</script>
